import { CallTarget } from '@/api/openapi';
import SalesforceConst from '@/const/salesforce';

/**
 * リードがSalesforceと同期済み（synced）かどうか
 *
 * NOTE: CallTargetの型定義上sfRelatedLinkInfoは必ず存在するが、getCallTarget()で取れる値が空objectの場合があるためオプショナルチェーンを使用
 * @see src/store/user/mutations.js::[CLEAR_CALL_TARGET]()
 */
const isLeadSynced = (callTarget: CallTarget | null | undefined): boolean =>
  callTarget?.sfRelatedLinkInfo?.sfRelatedLinks?.[0]?.status === SalesforceConst.Synced;

export {
  isLeadSynced,
};
